<template>
  <router-view />
</template>

<script lang="ts" setup>
import { onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { WOW } from "wowjs";
import HomeApi from "./api/homeApi";

const router = useRouter();

let wow = null;

watch(
  () => router.currentRoute.value,
  (to, from) => {
    wow = new WOW();
    wow.init();
  }
);

onMounted(async () => {
  await HomeApi.addHomeBrower();
})
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei, PingFangSC-Regular, PingFang Songti SC;
  color: var(--font-color);
  font-size: 16px;
  scrollbar-width: none;

  @media (min-width: 1680px) {
    font-size: 16px;
  }

  @media (max-width: 1680px) {
    font-size: 15px;
  }

  @media (max-width: 1280px) {
    font-size: 14px;
  }

  @media(max-width:960px) {
    scrollbar-width: auto;
  }

  @media(max-width:768px) {
    font-size: 12px;
  }
}

::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.1);
}

// /*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: rgba(0, 0, 0, 0.1);
}

.globalTitle {
  font-weight: 500;
  font-size: 24px;
  color: #26a078;
  line-height: 33px;
  margin-bottom: 32px;
}

.globalContent {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: justify;
  margin-bottom: 40px;
  word-break: break-all;
}
</style>
